<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sS1VRI/tc-custom/9781631941993.jpg?1705201909919" alt="This image is the cover for the book Haunted Martyr, Denton"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Martyr, Denton
      </h1>
      <p class="bookDescription body article font2">
        <b>The expat author travels to Italy, where communing with the dead can lead to murder, in this historical mystery by the author of <i>The Second Woman</i>.</b><br/><br/> England in the chilly winter of 1902 is captive to a new craze: Mediums and psychics are springing up like toadstools after a rainstorm, and the public is rushing to consult them, thirsty for intimations of the Great Beyond. It’s no surprise that a man like Denton has his doubts: An American Yankee in King Edward's city, he is a walking representative of the “Show Me” state.<br/><br/> Nevertheless, Denton agreed to write a book about ghosts and hauntings, and has taken himself to Italy to do it. Napoli may be <i>bella</i>, but it offers Denton only boredom and frustration, until a dead body shows up to make life interesting. As he tries to divine the killer’s identity, the cold hard clues give him a new angle on his new spiritualist friends.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kenneth Cameron
      </h2>
      
      <p class="authorDescription body article">Kenneth Cameron, AKA George Bartram, was born June 26, 1931, in Rochester, NY. He is the author of three previous novels featuring Denton, an American with a violent past: THE FRIGHTENED MAN, THE BOHEMIAN GIRL, and THE SECOND WOMAN. Cameron is also the author or co-author of more than thirty books, including historical fiction and espionage, a critical history of the African safari, and an award-winning analysis of films about Africa.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Felony & Mayhem Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34d18a4e